import i18n from '../../i18n';

import en from './locales/en.json';
import ru from './locales/ru.json';

const scopeName = 'shared/utils/validation';

i18n.addResourceBundle('en', scopeName, en);
i18n.addResourceBundle('ru', scopeName, ru);

export const getMessage = (key: string, params?: Record<string, unknown>) => {
  return i18n.t(key, { ...params, ns: scopeName });
};
